/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Binary — Convert Text ↔ Binary | Toolverse`)
};

const es_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto a Binario — Convierte Texto ↔ Binario | Toolverse`)
};

const de_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text in Binärcode — Text ↔ Binär konvertieren | Toolverse`)
};

const nl_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst naar binair — Converteer Tekst ↔ Binair | Toolverse`)
};

const fr_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte en Binaire — Convertir Texte ↔ Binaire | Toolverse`)
};

const it_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo a Binario — Converti Testo ↔ Binario | Toolverse`)
};

const pt_br2_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para Binário — Converta Texto ↔ Binário | Toolverse`)
};

const pt_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto para Binário — Converter Texto ↔ Binário | Toolverse`)
};

const ja_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to Binary — Convert Text ↔ Binary | Toolverse`)
};

const zh_tb_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转二进制 — 文本 ↔ 二进制互转 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_meta_title", locale)
	if (locale === "en") return en_tb_meta_title(inputs)
	if (locale === "es") return es_tb_meta_title(inputs)
	if (locale === "de") return de_tb_meta_title(inputs)
	if (locale === "nl") return nl_tb_meta_title(inputs)
	if (locale === "fr") return fr_tb_meta_title(inputs)
	if (locale === "it") return it_tb_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_tb_meta_title(inputs)
	if (locale === "pt") return pt_tb_meta_title(inputs)
	if (locale === "ja") return ja_tb_meta_title(inputs)
	return zh_tb_meta_title(inputs)
};